<template>
    <div class="scc-spinner">
        <div class="scc-spinner__inner"></div>
    </div>
</template>

<script>
import './spinner.scss';

export default {
    name: 'Spinner',
    props: {
        colors: {
            type: String,
            default: 'white',
        },
        size: {
            type: Number,
            default: 80,
        },
        color: {
            type: String,
            default: '#333333',
        },
        duration: {
            type: Number,
            default: 1200,
        },
    },
};
</script>
